import { render, staticRenderFns } from "./ParametersG20KzgList.vue?vue&type=template&id=2b8edeaf&scoped=true"
import script from "./ParametersG20KzgList.vue?vue&type=script&lang=js"
export * from "./ParametersG20KzgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8edeaf",
  null
  
)

export default component.exports